import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { getSingleStudent, updateStudent } from '../../helper/student_helper'; // Note: Not used here, but keeping if needed elsewhere
import { toast } from 'react-toastify'; // Optional, if you want to replace alert

const AccountSecurity = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    reEnterNewPassword: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Password Data: ", passwordData);
    
    // Basic validation
    if (passwordData.newPassword !== passwordData.reEnterNewPassword) {
      alert("New passwords do not match!");
      return;
    }
    if (passwordData.newPassword.length < 6) {
      alert("New password must be at least 6 characters!");
      return;
    }
    
    // TODO: Integrate with backend API similar to updateStudent
    alert("Password updated!"); // Replace with toast.success("Password updated!") if using toast
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Card elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <CardContent sx={{ p: { xs: 2, md: 4 } }}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3
            }}
          >
            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1 }}>
              Account Security
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Change Your Password Here
            </Typography>

            <TextField
              fullWidth
              label="Current Password"
              type="password"
              name="currentPassword"
              placeholder="Enter current password"
              value={passwordData.currentPassword}
              onChange={handleChange}
              variant="outlined"
              required
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              label="New Password"
              type="password"
              name="newPassword"
              placeholder="Enter new password"
              value={passwordData.newPassword}
              onChange={handleChange}
              variant="outlined"
              required
              sx={{ mb: 2 }}
              helperText="Password must be at least 6 characters"
            />

            <TextField
              fullWidth
              label="Re-Enter New Password"
              type="password"
              name="reEnterNewPassword"
              placeholder="Re-enter new password"
              value={passwordData.reEnterNewPassword}
              onChange={handleChange}
              variant="outlined"
              required
              sx={{ mb: 3 }}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              size={isMobile ? 'medium' : 'large'}
              sx={{
                alignSelf: 'flex-start',
                px: 4,
                py: 1.5,
                '&:hover': {
                  bgcolor: 'primary.dark'
                }
              }}
            >
              Save
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default AccountSecurity;